<script>
/* eslint-disable */
// import {width, height} from 'uloc-vue'
export default {
  name: 'MapContextMenu',
  methods: {
    getCanvasXY (caurrentLatLng) {
      let scale = Math.pow(2, this.map.getZoom());
      let nw = new this.google.maps.LatLng(
        this.map.getBounds().getNorthEast().lat(),
        this.map.getBounds().getSouthWest().lng()
      );
      let worldCoordinateNW = this.map.getProjection().fromLatLngToPoint(nw);
      let worldCoordinate = this.map.getProjection().fromLatLngToPoint(caurrentLatLng);
      let caurrentLatLngOffset = new this.google.maps.Point(
        Math.floor((worldCoordinate.x - worldCoordinateNW.x) * scale),
        Math.floor((worldCoordinate.y - worldCoordinateNW.y) * scale)
      );
      return caurrentLatLngOffset;
    },

    setMenuXY (caurrentLatLng) {
      let mapWidth = this.$refs.googleMap.clientWidth
      let mapHeight = this.$refs.googleMap.clientHeight
      const contextMenu = document.querySelector('.map-contextmenu')
      let menuWidth = contextMenu.clientWidth;
      let menuHeight = contextMenu.clientHeight;
      let clickedPosition = this.getCanvasXY(caurrentLatLng);
      let x = clickedPosition.x;
      let y = clickedPosition.y;

      if ((mapWidth - x) < menuWidth)
        x = x - menuWidth;
      if ((mapHeight - y) < menuHeight)
        y = y - menuHeight;

      contextMenu.style.left = x + 'px'
      contextMenu.style.top = y + 'px'
    },

    showContextMenu (caurrentLatLng) {
      this.closeContextMenu()
      let projection;
      let contextmenuDir;
      projection = this.map.getProjection();
      contextmenuDir = document.createElement('div');
      contextmenuDir.className = 'map-contextmenu';
      contextmenuDir.innerHTML = '<a id=\'menu1\'><div id=solicitarRemocaoPoint>Solicitar remoção aqui<\/div><\/a><a id=\'menu2\' class="cancel"><div class=\'context\'>Cancelar<\/div><\/a>';
      // contextmenuDir.addEventListener('click', this.closeContextMenu)
      this.$currentLatLng = caurrentLatLng
      document.addEventListener('click', this.closeContextMenu)
      // $(this.map.getDiv()).append(contextmenuDir);
      this.map.getDiv().append(contextmenuDir)

      this.setMenuXY(caurrentLatLng);

      contextmenuDir.style.visibility = 'visible';
    },

    closeContextMenu (e) {
      if (e && e.target.id === 'solicitarRemocaoPoint') {
        console.log('TARGET: ', this.$currentLatLng.toJSON())
      }
      const contextMenu = document.querySelector('.map-contextmenu')
      if (contextMenu) {
        // contextMenu.removeEventListener('click', this.closeContextMenu)
        document.removeEventListener('click', this.closeContextMenu)
        contextMenu.remove();
      }
    }
  }
}
</script>

<style lang="scss">
  .map-contextmenu {
    visibility: hidden;
    background: #ffffff;
    border: 1px solid #8888FF;
    z-index: 10;
    position: relative;
    width: auto;
    display: inline-flex;
    flex-direction: column;
    padding: 10px;
    border-radius: 0 5px 5px;
    -webkit-box-shadow: 10px 10px 13px -8px rgba(0,0,0,0.3);
    -moz-box-shadow: 10px 10px 13px -8px rgba(0,0,0,0.3);
    box-shadow: 10px 10px 13px -8px rgba(0,0,0,0.3);

    a {
      color: #333333;
      padding: 4px 0;

      &.cancel {
        color: #CC2E2E !important;
      }
    }
  }

  .map-contextmenu div {
    padding-left: 5px
  }
</style>



// WEBPACK FOOTER //
// ContextMenu.vue?31cc5dfe